import { useEffect, useState } from "react";
import { auth } from "../firebase/firebase";
import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { showMessage } from "../components/message/GenericMessage";

export const useAuth = () => {
  const [user, setCurrentUser] = useState(null);
  const [loggedIn, setLoggedIn] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setCurrentUser(currentUser);
        setLoggedIn(true);
      } else {
        setCurrentUser(null);
        setLoggedIn(false);
      }
    });
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      showMessage("Login successful", "success");
    } catch (error) {
      console.log(error);
      showMessage(error.message, "error");
    }
    setLoading(false);
  };

  const logout = async () => {
    await signOut(auth);
    showMessage("Signed out");
  };

  return {
    login,
    loggedIn,
    user,
    loading,
    logout,
    // component,
  };
};
